import './PriceLoadingValue.scss';

interface PriceLoadingValueProps {
  className?: string;
  showSecondary?: boolean;
}

export const PriceLoadingValue = ({ className = '', showSecondary = true }: PriceLoadingValueProps) => {
  const classes = ['of-price-loading', className].filter(Boolean).join(' ');

  return (
    <div className={classes} aria-hidden="true">
      <div className="of-price-loading__primary" />
      {showSecondary && <div className="of-price-loading__secondary" />}
    </div>
  );
};
